
export default function HowItWorks() {
  const steps = [
    {
      number: 1,
      title: 'We build a demo website for your business',
      description: 'Our team creates a professional demo website tailored to your business needs and brand identity',
      icon: 'ri-code-s-slash-line'
    },
    {
      number: 2,
      title: 'We show it to you on a Google Meet call',
      description: 'Schedule a quick call where we walk you through the demo and gather your feedback',
      icon: 'ri-video-chat-line'
    },
    {
      number: 3,
      title: 'You approve the site',
      description: 'Review the demo, request any changes, and approve when you\'re completely satisfied',
      icon: 'ri-checkbox-circle-line'
    },
    {
      number: 4,
      title: 'We publish it live',
      description: 'Once approved, we launch your website and make it available to your customers',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section id="process" className="relative py-32 bg-gradient-to-br from-[#050a14] via-[#0a1628] to-black overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#1e3a8a] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#0a1628] rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="mb-20">
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-4">How It Works</h2>
          <p className="text-2xl text-white/70 italic font-light">Simple. Transparent. Effective.</p>
        </div>

        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#1e3a8a] via-[#0a1628] to-[#1e3a8a] hidden lg:block"></div>

          <div className="space-y-16">
            {steps.map((step, index) => (
              <div key={index} className="relative flex items-start gap-8">
                <div className="flex-shrink-0 w-16 h-16 bg-[#0a1628] border border-[#1e3a8a]/50 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg shadow-[#1e3a8a]/20 z-10">
                  {step.number}
                </div>
                
                <div className="flex-1 pt-2">
                  <h3 className="text-3xl font-bold text-white mb-3">{step.title}</h3>
                  <p className="text-lg text-white/70 max-w-xl leading-relaxed">{step.description}</p>
                </div>

                <div className="hidden xl:flex flex-shrink-0 w-16 h-16 items-center justify-center">
                  <i className={`${step.icon} text-5xl text-[#1e3a8a]/30`}></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
